var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintIconColour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#2FCCC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.521 30V23.75H33.4775V30",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.325 40H17.6729C17.3967 40 17.1729 39.7761 17.1729 39.5V23.75L32.825 23.7502V39.5C32.825 39.7761 32.6012 40 32.325 40Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 29.9995L13.0335 30.0354C11.3636 30.054 10 28.7055 10 27.0356V19.8887C10 19.3364 10.4477 18.8887 11 18.8887H39C39.5523 18.8887 40 19.3364 40 19.8887V27.0356C40 28.7055 38.6364 30.054 36.9665 30.0354L33.75 29.9995",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6675 17.2917V12.5H33.3341V17.2917",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIconColour);
export default __webpack_public_path__ + "static/media/PrintIconColour.ad9fbfe885d00eb0ab1106adb59dfeed.svg";
export { ForwardRef as ReactComponent };